import React from 'react';

export type VerticalLayoutProps = {
  children: React.ReactNode
  gap?: number
  justify?: 'center' | 'space-between' | 'end'
  align?: 'center' | 'end' | 'start'
  width?: '100%'
  minHeight?: string
  height?: '100%'
  overflow?: 'scroll'
};

export const VerticalLayoutUI: React.FC<VerticalLayoutProps> = ({ children, gap, justify, align, width, minHeight, height, overflow }) => {
  const scrollOverride = overflow === 'scroll' ? 'auto' : undefined;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: justify, alignItems: align, gap, width, minHeight, height, overflowY: scrollOverride, scrollbarWidth: 'thin' }}>
      {children}
    </div>
  );
};
